import React, {useState} from 'react';
import {Outlet, useLocation} from 'react-router-dom';
import {Box} from '@mui/material';

import {DocumentViewerProvider, useDocumentViewer} from '../../context/DocumentViewerContext';
import {RightSideBarProvider, useRightSideBar} from '../../context/RightSideBarContext';

import ChatContainer from '../../containers/chat/ChatContainer';
import SectionSwitchFab from '../common/SectionSwitchFab';
import DocumentViewer from '../document-viewer/DocumentViewer';
import ChatSideBar from './chat/SideBar';
import LayoutFrame from './LayoutFrame';
import SideBarRight from './SideBarRight';

export default function UserAppLayout() {
    const { pathname } = useLocation();

    if (pathname.startsWith('/chat')) {
        return (
            <RightSideBarProvider>
                <DocumentViewerProvider>
                    <ChatLayout />
                </DocumentViewerProvider>
            </RightSideBarProvider>
        );
    }

    if (pathname.startsWith('/idea')) {
        return (
            <RightSideBarProvider>
                <DocumentViewerProvider>
                    <IdeaLayout />
                </DocumentViewerProvider>
            </RightSideBarProvider>
        );
    }

    return (
        <LayoutFrame
            leftSideBar={null}
            middleSideBar={null}
            rightSideBar={null}
        >
            <Outlet />
        </LayoutFrame>
    );
}

function ChatLayout() {
    const { isOpenRightSideBar: isDocOpen } = useDocumentViewer();
    const { isOpenRightSideBar, rightContent, rightWidth } = useRightSideBar();

    const [isMiddleSideBar, setIsMiddleSideBar] = useState(true);

    const handleToggleSideBar = () => setIsMiddleSideBar((prev) => !prev);

    const chatSideBar = (
        <ChatSideBar
            isMiddleSideBar={isMiddleSideBar}
            onToggleSideBar={handleToggleSideBar}
        />
    );

    const rightSideBar = isDocOpen
        ? <SideBarRight content={<DocumentViewer />} />
        : isOpenRightSideBar
            ? <SideBarRight content={rightContent} width={rightWidth} />
            : null;

    return (
        <LayoutFrame
            leftSideBar={!isMiddleSideBar ? chatSideBar : null}
            middleSideBar={isMiddleSideBar ? chatSideBar : null}
            rightSideBar={rightSideBar}
        >
            <Outlet />
            <SectionSwitchFab />
        </LayoutFrame>
    );
}

function IdeaLayout() {
    const [isMiddleSideBar, setIsMiddleSideBar] = useState(true);

    const handleToggleSideBar = () => setIsMiddleSideBar((prev) => !prev);

    const chatSideBar = (
        <ChatSideBar
            isMiddleSideBar={isMiddleSideBar}
            onToggleSideBar={handleToggleSideBar}
        />
    );

    const reservedSidebarPx = isMiddleSideBar ? 260 : 85;
    const ideaPanelWidth = `calc((100vw - ${reservedSidebarPx}px) / 2)`;

    const ideaChatPanel = (
        <SideBarRight
            width={ideaPanelWidth}
            content={
                <Box sx={{ width: '100%', height: '100%', overflow: 'auto' }}>
                    <ChatContainer />
                </Box>
            }
        />
    );

    return (
        <LayoutFrame
            leftSideBar={!isMiddleSideBar ? chatSideBar : null}
            middleSideBar={isMiddleSideBar ? chatSideBar : null}
            rightSideBar={ideaChatPanel}
        >
            <Outlet />
            <SectionSwitchFab />
        </LayoutFrame>
    );
}
